// src/components/Institution/Dashboard/KpiTotals.js
import React from "react";
import { Row, Col, Card, Statistic, Button } from "antd";
import { Link } from "react-router-dom";
import { TeamOutlined, UserOutlined, ReadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const iconMap = {
  teachers: <UserOutlined style={{ color: "#52c41a" }} />,
  students: <TeamOutlined style={{ color: "#722ed1" }} />,
  simulator: <ReadOutlined style={{ color: "#faad14" }} />,
};

// Rutas del router de institución (según AdminRouter.js)
const linkMap = {
  teachers: "/inst/teachers",
  students: "/inst/students",
  // simulator: "/inst/educamaker" // Opcional si quieres enlazar
};

export function KpiTotals({ totals }) {
  const { t } = useTranslation("dashboard");
  const totalsData = totals || {};

  const items = [
    { key: "teachers", label: t("institution.kpi.teachers"), value: totalsData.teachers ?? 0 },
    { key: "students", label: t("institution.kpi.students"), value: totalsData.students ?? 0 },
    {
      key: "simulator",
      label: t("institution.kpi.resources"),
      value: totalsData.simulator?.institutions ?? 0,
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {items.map(({ key, label, value }) => {
        const link = linkMap[key];
        const actions = link
          ? [
              <Link key="inspect" to={link}>
                <Button type="link" aria-label={`${t("institution.kpi.manage")} ${label}`}>
                  {t("institution.kpi.manage")}
                </Button>
              </Link>,
            ]
          : undefined;

        return (
          <Col key={key} xs={24} sm={8}>
            <Card
              variant="outlined"
              hoverable
              style={{ borderRadius: 10 }}
              actions={actions}
            >
              <Statistic title={label} value={value} prefix={iconMap[key]} />
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
